export default function guestMiddleware(context) {
  const { next, userStore, to } = context;

  if (userStore.isAuthenticated && (to.name === 'Login' || to.name === 'Register')) {
    return next({ name: 'Dashboard' });
  }

  return next();
}
